import IxigoMoney from '@ixigo/icons/IxigoMoneyFilled';
import Typography from '@ixigo/iui/Typography';
import { formatPrice } from '@repo/shared/utils/priceFormatter';
import type { BaseCabItemOption, BaseFareSummary } from '@/api';
import type { DiscountFareItem } from '../index.types';

export interface FareLineItemsResult {
	/** Array of charge items to display */
	charges: BaseFareSummary[];
	/** Array of discount items to display */
	discounts: DiscountFareItem[];
}

export function getFareLineItems(
	cabPricing?: BaseCabItemOption['pricing'],
	burnOpted?: boolean,
): FareLineItemsResult {
	if (!cabPricing) {
		return {
			charges: [],
			discounts: [],
		};
	}
	const { basePrice, taxes, discount, burn, currency } = cabPricing;

	// Build charges array
	const charges: BaseFareSummary[] = [
		{
			label: 'Cab Charges',
			value: formatPrice(basePrice, { currency }),
			amount: basePrice,
		},
		...(taxes > 0
			? [
					{
						label: 'Taxes & Fees',
						value: formatPrice(taxes, { currency }),
						amount: taxes,
					},
				]
			: []),
	];

	// Build discounts array
	const discounts: FareLineItemsResult['discounts'] = [];
	if (discount > 0) {
		discounts.push({
			label: 'Coupon Discount',
			value: `-${formatPrice(discount, { currency })}`,
			amount: discount,
			valueColor: 'text-success',
		});
	}
	if (burn > 0 && burnOpted) {
		discounts.push({
			label: (
				<Typography variant="body-md">
					Redeem ixigo Money <IxigoMoney className="size-20 text-brand" />
				</Typography>
			),
			value: `-₹${burn}`,
			amount: burn,
			valueColor: 'text-success',
		});
	}

	return {
		charges,
		discounts,
	};
}
